import React from 'react';
import { PageTitleZoneNext } from '../../../../components/page-title-zone';

export interface ICourseTitlezoneProps {
  isEditMode: boolean;
  courseName?: string;
  isCompleted: boolean;
}

export function CourseTitlezone(props: ICourseTitlezoneProps) {
  const { isEditMode, courseName, isCompleted } = props;
  const title = isEditMode ? 'Redigér hold' : 'Opret hold';
  const subtitle = (
    <span>
      {courseName}{' '}
      <span style={{ fontSize: '14px' }}>({isCompleted ? 'Afsluttet' : 'Aktivt'})</span>
    </span>
  );
  return <PageTitleZoneNext isLoading={false} entityName="Hold" title={title} subtitle={subtitle} />;
}
